module.exports = require("source-map-support/register");


//////////////////
// WEBPACK FOOTER
// external "source-map-support/register"
// module id = 4
// module chunks = 0